module.exports = __webpack_public_path__ + "img/智能变配电单位概况2.7fc63c2d.png";